
const imageurl = "https://api.evolvejobs.de/pp/api/public/images";
//const imageurl = "http://apievcustomer.de/pp/api/public/images";
export default imageurl;